import $ from 'jquery';
export default class Footer {
    static mount() {
        $(function () {
            new Footer();
        });
    }
    constructor() {
        this.$element = $('footer.footer--page');
        this.$scrollToTopButton = $('.scroll-to-top-button a', this.$element);
        this.$scrollToTopButtonContainer = $('.scroll-to-top-container', this.$element);
        this.registerEvents();
    }
    registerEvents() {
        this.$scrollToTopButton.on('click', this.scrollToTop);
        $(window).on('scroll resize', () => {
            this.watchScroll();
        });
    }
    scrollToTop() {
        $('html, body').animate({ scrollTop: 0 }, 800);
    }
    watchScroll() {
        var _a;
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        if (!scrollTop || !windowHeight)
            return;
        const scrollBottom = scrollTop + windowHeight;
        const offset = parseInt(this.$element.css('--cm-scroll2top-offset'));
        const footerTop = (_a = this.$element.offset()) === null || _a === void 0 ? void 0 : _a.top;
        if (footerTop && scrollBottom < (footerTop)) {
            this.$scrollToTopButtonContainer.addClass('fixed');
        }
        else if (footerTop && scrollBottom >= footerTop) {
            this.$scrollToTopButtonContainer.removeClass('fixed');
        }
        else {
            this.$scrollToTopButtonContainer.removeClass('fixed');
        }
        if (scrollTop < offset) {
            this.$scrollToTopButtonContainer.removeClass('visible');
            this.$scrollToTopButtonContainer.addClass('hidden');
        }
        else {
            this.$scrollToTopButtonContainer.addClass('visible');
            this.$scrollToTopButtonContainer.removeClass('hidden');
        }
    }
}
